import matchSorter, { rankings } from "match-sorter";
import { gql } from "apollo-boost";

export default function filterProducts(products, { text } = {}) {
  return matchSorter(products, text, {
    keys: [
      "name",
      "nameWithProducerAndVintage",
      { key: "vintage", threshold: rankings.STARTS_WITH },
      { key: "producerName.shortName", threshold: rankings.CONTAINS },
      { key: "stand.name", threshold: rankings.STARTS_WITH },
      {
        key: "region.text",
        // Rank "Steiermark" and "Steiermark Sekt g.U." equally for region searches.
        maxRanking: rankings.WORD_STARTS_WITH
      },
      { key: "producerName.name", threshold: rankings.CONTAINS }
    ]
  });
}

export const fragment = gql`
  fragment ProductsSearch on ProductsConnection {
    edges {
      node {
        id
        name
        nameWithProducerAndVintage
        vintage
        producer {
          producerId: id
          producerName {
            shortName
            name
          }
        }
        stand {
          name
        }
        region {
          text
        }
      }
    }
  }
`;
